import { useSelector } from 'react-redux'
import ContentButton from '../../../components/core/player-parts/ContentButton'
import { seasonalStation } from '../../../config/stations'
import { appBasePath } from '../../../config/app'
import './styles.scss'
const imageLg = `${appBasePath}/assets/seasonalstation/banner-lg.png`
const imageSm = `${appBasePath}/assets/seasonalstation/banner-sm.png`
const imageXs = `${appBasePath}/assets/seasonalstation/banner-xs.png`

const SeasonalStation = () => {
  const stationState = useSelector(state => state[seasonalStation.id])
  if (!stationState) return null
  if (stationState.status !== 'on-line') return null
  stationState.source_url = stationState.src
  stationState.title = stationState.public_name
  return (
    <figure className='seasonal-station'>
      <ContentButton preferedTrack={stationState} content={stationState} />
      <picture>
        <source
          srcSet={imageXs}
          media='(max-width: 360px)'
        />
        <source
          srcSet={imageSm}
          media='(max-width: 991px)'
        />
        <img
          src={imageLg}
          alt=''
        />
      </picture>
    </figure>
  )
}

export default SeasonalStation
/*
  <section className='seasonal-station'>
    <figcaption>
      <p>Seasonal Station</p>
    </figcaption>
    <figure>
      <IonImg src={image} />
    </figure>
  </section>
*/
